import { ProgramNames } from '../../../models/programs/Programs'
import { PROVIDER_TYPES } from '../../../models/providers/Providers'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { LTSessionTypes } from '../../sessions/constants'
import { ConsentText, ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const ALCOHOL_USE_DISORDER_THERAPY_PROGRAM = {
  programName: ProgramNames.AlcoholUseDisorderTherapy,
  blendedCareProgramId: 'edcea864-b6eb-4d16-8c4c-ce748c18025e',
  customerPropertyId: ProgramCustomerPropertyId.alcoholUseDisorderTherapy,

  displayLabels: {
    default: ProgramDisplayLabels.renew,
    sessionSummary: 'Renew',
  },

  associatedProviderTypes: [PROVIDER_TYPES.LYRATHERAPIST.lyraType],
  associatedProviderModalities: ['alcoholUseDisorderTherapy'],

  canRescheduleAppointment: true,
  selfPayEligible: true,
  supportsEpisodeInsights: true,

  sessionTypeConfig: {
    sessionType: LTSessionTypes.AUD_SESSION,
    rateStrategy: 'fixed',
  },

  directBookingParams: {
    clientele: PROGRAM_TAXONOMY.clientele.individual,
    treatment: PROGRAM_TAXONOMY.treatment.therapy,
    partner: PROGRAM_TAXONOMY.partner.blendedCare,
    offering: PROGRAM_TAXONOMY.offering.alcoholUseDisorder,
  },

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.ALCOHOL_USE_DISORDER],
    isFullTreatmentOption: true,
  },

  consents: [
    {
      consentText: ConsentText.alcoholUseDisorderConsent,
      consentUrl: 'https://www.lyrahealth.com/aud-agreement',
      showConsentIf: () => true,
    },
  ],

  noteContentMetadataName: {
    INITIAL_NOTE: 'audSudExpansionInitialNote',
    SESSION_NOTE: 'audSudExpansionSessionNote',
    GENERAL_NOTE: 'audSudExpansionGeneralNote',
    REFERRAL_NOTE: 'baseReferralNote',
    OLD_INITIAL_NOTE: 'audInitialNote',
    OLD_SESSION_NOTE: 'audSessionNote',
    OLD_GENERAL_NOTE: 'audGeneralNote',
  },
} satisfies ProgramConfig
